import * as types from '../actionsTypes/giustificativiActionType';
import {datiRegistroActions, loadingOverlayActions, notifsActions} from "../index";
import new_axios_instance from '../../axios_instance';
import {createMessageRequestException, printOnlyInDevelopment} from "../../fanctionUtility";


export const initTipiGiustificativi = () => {
    return {
        type: types.INIT_TIPI_GIUSTIFICATIVI
    }
};

export const initRequestGiustificativi = () => ({
    type: types.INIT_REQUEST_GIUSTIFICATIVI
});

//GET /v1/tipogiustificativo/ricerca/tipoCorso/{tipoCorso}
/*export const getTipoGiustificativiByTipoCorso = (tipoCorso) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(getTipoGiustificativiByTipoCorsoAction());
    await new_axios_instance.get(`/v1/tipogiustificativo/ricerca/tipoCorso/${tipoCorso}`)
        .then(response => {
            dispatch(getTipoGiustificativiByTipoCorsoSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        }).catch(error => {
            const message = createMessageRequestException(error);

            dispatch(getTipoGiustificativiByTipoCorsoFail(message));
            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
};*/

export const getTipoGiustificativiByTipoCorsoAction = () => {
    return {
        type: types.GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_ACTION
    }
};

export const getTipoGiustificativiByTipoCorsoSuccess = (arryGiustificativi) => {
    return {
        type: types.GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_SUCCESS,
        giustificativi: arryGiustificativi
    }
};

/*const getTipoGiustificativiByTipoCorsoFail = (error) => {
    return {
        type: types.GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_FAIL,
        giustificativiError: error
    }
};*/


/************************* Recupro tutti i tipi di Giustificativi *****************/

export const getAllTipoGiustificativi = () => async dispatch => {
    await new_axios_instance.get(`/v1/tipogiustificativo/ricerca`)
        .then(response => {
            dispatch(getAllTipoGiustificativiSuccess(response.data));
        }).catch(error => {
            const messageError = createMessageRequestException(error);
            dispatch(getAllTipoGiustificativiFail(messageError));
            dispatch(notifsActions.notifError(messageError));
        });
};

const getAllTipoGiustificativiSuccess = (tipiGiustificativi) => {
    return {
        type: types.GET_ALL_TIPI_GIUSTIFICATIVI_SUCCESS,
        tipiGiustificativi: tipiGiustificativi
    }
};

const getAllTipoGiustificativiFail = (error) => {
    return {
        type: types.GET_ALL_TIPI_GIUSTIFICATIVI_FAIL,
        error: error
    }
};

/************************* Recupro tutti i tipi di Giustificativi *****************/

/******************************* Aggiorna Giustificativo **********************************/

export const aggiornaGiustificativo = (giustificativo) => async dispatch => {
    dispatch(initUpdateFields());
    dispatch(loadingOverlayActions.showLoadingOverlay());
    await new_axios_instance.put(`/v1/tipogiustificativo/aggiorna`, giustificativo)
        .then(response => {
            printOnlyInDevelopment('RESPONSE AGGIORNAMENTO GIUSTIFICATIVO', response);
            dispatch(updateSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            const messageError = createMessageRequestException(error);
            dispatch(notifsActions.notifError(messageError));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
};

const updateSuccess = (giustificativoUpdated) => {
    return {
        type: types.UPDATE_SUCCESS,
        giustificativoUpdated: giustificativoUpdated
    }
};

export const initUpdateFields = () => {
    return {
        type: types.INIT_UPDATE_FIELDS
    }
};

/******************************* Aggiorna Giustificativo **********************************/

/******************************* Inserisci Tipo Giustificativo **********************************/

export const inserisciGiustificativo = (newGiustificativo) => async dispatch => {
    dispatch(initUpdateFields());
    dispatch(loadingOverlayActions.showLoadingOverlay());
    await new_axios_instance.post(`/v1/tipogiustificativo/inserisci`, newGiustificativo)
        .then(response => {
            printOnlyInDevelopment('RESPONSE INSERIMENTO NUOVO GIUSTIFICATIVO', response.data);
            dispatch(getAllTipoGiustificativi());
            dispatch(insertTipoGiustificativoSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
            dispatch(notifsActions.notifSuccess('Operazione conclusa con successo'));
        })
        .catch(error => {
            const messageError = createMessageRequestException(error);
            dispatch(notifsActions.notifError(messageError));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
};

const insertTipoGiustificativoSuccess = (nuovoGiustificativo) => {
    return {
        type: types.INSERT_TIPO_GIUSTIFICATIVO_SUCCESS,
        nuovoGiustificativo: nuovoGiustificativo
    }
};
/******************************* Inserisci Tipo Giustificativo **********************************/

/******************************* Inserisci Giustificativo **********************************/
/*export const addGiustificativo = (giustificativo, navigate, type, tab, nomeIndividuo) => async dispatch => {
    dispatch(addGiustificativoAction());
    if (type === TYPE_INSERT.SINGLE_MANUAL) {
        dispatch(loadingOverlayActions.showLoadingOverlay());
    }
    await new_axios_instance.post('/v1/giustificativo/inserisci', giustificativo)
        .then(() => {
            dispatch(addGiustificativoSuccess());

            if (type === TYPE_INSERT.SINGLE_MANUAL) {
                dispatch(notifSuccess('Giustificativo inserito con successo'));
                dispatch(loadingOverlayActions.hideLoadingOverlay());
                dispatch(initRequestGiustificativi());
                navigate(`/corso/${giustificativo.idCorso}/registro/${giustificativo.idAnagrafica}/dettaglio?${queryString.stringify({data: dayJS(giustificativo.dataInizio,'YYYY-MM-DD').format('YYYY-MM'), tab})}`);
                window.scrollTo({top: 0, behavior: "smooth"})
            }
        }).catch(error => {
            const message = createMessageRequestException(error);

            if (type === TYPE_INSERT.SINGLE_MANUAL) {
                // dispatch(addGiustificativoFail());
                dispatch(notifError(message));
                dispatch(initRequestGiustificativi());
                dispatch(loadingOverlayActions.hideLoadingOverlay());
            } else if (type === TYPE_INSERT.MULTI_MANUAL) {
                dispatch(addGiustificativoFail(message, nomeIndividuo));
            }
        });
};*/



export const addGiustificativoEnd = (errors = []) => ({
    type: types.ADD_GIUSTIFICATIVO_END,
    errors
});
export const addGiustificativoAction = (datiGiustificativo) => ({
    type: types.ADD_GIUSTIFICATIVO_ACTION,
    payload: datiGiustificativo
});






/*export const addGiustificativoSuccess = () => ({
    type: types.ADD_GIUSTIFICATIVO_SUCCESS
});

export const addGiustificativoFail = (error, nomeIndividuo) => ({
    type: types.ADD_GIUSTIFICATIVO_FAIL,
    error,
    nomeIndividuo
});*/

/******************************* Inserisci Giustificativo **********************************/

/******************************* Delete Giustificativo *******************************/

export const deleteGiustificativo = (idGiustificativo, param, tab) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(deleteGiustificativoAction());
    await new_axios_instance.delete(`/v1/giustificativo/elimina/${idGiustificativo}`)
        .then(() => {
            dispatch(datiRegistroActions.ricercaTimbratureStartPerRegistroAction([param], tab));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
            dispatch(getDeleteGiustificativoSuccess());
            dispatch(notifsActions.notifSuccess('Operazione avvenuta con successo'));
        })
        .catch(error => {
            const message = createMessageRequestException(error);

            dispatch(notifsActions.notifError(message));
            dispatch(getDeleteGiustificativoError());
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
};

//export for testing
export const deleteGiustificativoAction = () => ({
    type: types.DELETE_GIUSTIFICATIVO_ACTION
});

const getDeleteGiustificativoSuccess = () => {
    return {
        type: types.DELETE_GIUSTIFICATIVO_SUCCESS
    }
};

const getDeleteGiustificativoError = () => {
    return {
        type: types.DELETE_GIUSTIFICATIVO_FAIL
    }
};

/******************************* Delete Giustificativo *******************************/


